import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, Renderer2 } from '@angular/core';
import { NzFormItemComponent } from 'ng-zorro-antd/form';
import { Subscription } from 'rxjs';
import { QuestionSelectService } from '@workflow/queries/services/question-select.service';

@Component({
	selector: 'workflow-select-question-input',
	templateUrl: './select-question-input.component.html',
	styleUrls: ['./select-question-input.component.scss'],
})
export class SelectQuestionInputComponent extends NzFormItemComponent implements OnDestroy {
	@Input()
	public label?: string;
	@Input()
	public placeholder?: string;
	
	private _key: string | null;
	
	@Output()
	public readonly keyChange = new EventEmitter<string | null>();
	
	@Input()
	public set key(value: string | null) {
		if (value !== this._key) {
			this._key = value;
			
			this._subscription?.unsubscribe();
			if (value) {
				this._subscription = this.questionSelectService.highlight(value);
			} else {
				this._subscription = undefined;
			}
			
			this.keyChange.emit(value);
		}
	}
	public get key(): string | null {
		return this._key;
	}
	
	private _subscription?: Subscription;
	
	private _selecting?: Subscription;
	
	constructor(
		private readonly questionSelectService: QuestionSelectService,
		elementRef: ElementRef,
		renderer: Renderer2,
		cdr: ChangeDetectorRef,
	) {
		super(elementRef, renderer, cdr);
	}
	
	public select(): void {
		if (this._selecting) {
			this._selecting.unsubscribe();
			this._selecting = undefined;
		} else {
			this._selecting = this.questionSelectService.select()
				// eslint-disable-next-line rxjs-angular/prefer-composition
				.subscribe(key => this.key = (key));
		}
	}
	
	public ngOnDestroy(): void {
		super.ngOnDestroy();
		this._subscription?.unsubscribe();
	}
}
